// @flow

import { ADD_CONTACT } from "../actions"

export default ( state: any = [], action: any ) => {
  switch ( action.type ) {
  case ADD_CONTACT:
    return action.response
  default:
    return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/contactHistory.jsx